import { render, staticRenderFns } from "./surveyDetail.vue?vue&type=template&id=6041d16a&scoped=true"
import script from "./surveyDetail.vue?vue&type=script&lang=js"
export * from "./surveyDetail.vue?vue&type=script&lang=js"
import style0 from "./surveyDetail.vue?vue&type=style&index=0&id=6041d16a&prod&lang=scss&scoped=true"
import style1 from "./surveyDetail.vue?vue&type=style&index=1&id=6041d16a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041d16a",
  null
  
)

export default component.exports